import Stars from "./Stars";

const TestimonialCard = ({ item, mobile = false }) => {
  return (
    <>
      <p
        className={`leading-relaxed ${mobile ? "text-base mb-6 font-light" : "text-lg mb-6 font-light"}`}
      >
        {item.text}
      </p>
      <div className="flex items-center justify-between">
        <div className="flex gap-4">
          <img
            src={item.image}
            alt={item.name}
            className="w-12 h-12 rounded-full border-white"
          />
          <div>
            <p className="font-bold">{item.name}</p>
            <p className={mobile ? "text-sm text-blue-200" : "text-sm"}>
              {item.title}
            </p>
          </div>
        </div>
        <div>
          <Stars rating={item.ratings} />
        </div>
      </div>
    </>
  );
};

export default TestimonialCard;
